import { render, staticRenderFns } from "./OneTimeCode.vue?vue&type=template&id=72d81cad&scoped=true&"
import script from "./OneTimeCode.vue?vue&type=script&lang=ts&"
export * from "./OneTimeCode.vue?vue&type=script&lang=ts&"
import style0 from "./OneTimeCode.vue?vue&type=style&index=0&id=72d81cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d81cad",
  null
  
)

export default component.exports